/**
 * RFC4180 tokenizer. Character-driven on purpose: 19% of real bank descriptions
 * contain newlines INSIDE quoted fields, so anything that splits on '\n' before
 * parsing quotes corrupts one row in five.
 */
export function parseCsv(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;
  let i = text.charCodeAt(0) === 0xfeff ? 1 : 0;

  while (i < text.length) {
    const c = text[i];

    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i += 2; continue; }
        inQuotes = false; i++; continue;
      }
      field += c; i++; continue;               // newlines land here, kept verbatim
    }

    if (c === '"')  { inQuotes = true; i++; continue; }
    if (c === ',')  { row.push(field); field = ''; i++; continue; }
    if (c === '\r') { i++; continue; }
    if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; i++; continue; }

    field += c; i++;
  }

  if (field !== '' || row.length > 0) { row.push(field); rows.push(row); }

  // A blank line yields [''] — drop it, keep genuinely ragged rows.
  return rows.filter(r => !(r.length === 1 && r[0] === ''));
}
